import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import _omit from "lodash/omit";
import _isFunction from "lodash/isFunction";
var _excluded = ["setValues"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Form, Row, Col, Input, Button, DateTimePicker, CheckButton, Dropdown, PhonesInput, CheckboxSwitch, inputValidation, showError } from 'components/UI';
import { useUser, AddressInput } from 'components/shared';
import { showApiError } from 'utils';
import { dateFormat, maritalStatusNameSelect, educationStatusNameSelect, accommodationTypeNameSelect, employmentTypeNameSelect, carStatusNameSelect } from 'enums';
import { createBorrower, updateBorrower, getAllAreas } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";
var COUNTRY_ID = 1;

var sectionStyle = function sectionStyle(theme) {
  return {
    padding: '2em 0',
    borderBottom: "1px solid ".concat(theme.gray100),
    '&:first-of-type': {
      paddingTop: 0
    },
    '&:last-of-type': {
      borderBottom: 'none'
    }
  };
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    marginBottom: '1.6em',
    '& i': {
      fontSize: '1.8rem',
      color: theme.primary
    },
    '& h5': {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: theme.gray800,
      margin: 0
    }
  };
};

var toggleGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  gap: '1.2em'
};

var BorrowerDataForm = function BorrowerDataForm(_ref) {
  var _userInfo$currentOffi;

  var data = _ref.data,
      ocrData = _ref.ocrData,
      ocrAddressLists = _ref.ocrAddressLists,
      onBorrowerChange = _ref.onBorrowerChange,
      onNext = _ref.onNext,
      onBack = _ref.onBack,
      onCancel = _ref.onCancel;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      areas = _useState2[0],
      setAreas = _useState2[1];

  var isNew = data === null || data === void 0 ? void 0 : data.newBorrower;

  var borrowerData = _omit(data, ['contact_persons', 'contracts', 'credits', 'documents', 'employee', 'franchisee', 'history', 'office']);

  var ocrMapped = ocrData ? Object.fromEntries(Object.entries(ocrData).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        v = _ref3[1];

    return v !== null && v !== undefined;
  })) : {};

  var initialFormData = _objectSpread(_objectSpread(_objectSpread({}, borrowerData), ocrMapped), {}, {
    office_id: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi = userInfo.currentOffice) === null || _userInfo$currentOffi === void 0 ? void 0 : _userInfo$currentOffi.id,
    id_card_country_id: COUNTRY_ID,
    current_country_id: COUNTRY_ID
  });

  useEffect(function () {
    fetchAreas();
  }, []);

  var fetchAreas = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllAreas, _yield$getAllAreas2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllAreas({
                country_id: COUNTRY_ID
              });

            case 2:
              _yield$getAllAreas = _context.sent;
              _yield$getAllAreas2 = _slicedToArray(_yield$getAllAreas, 2);
              res = _yield$getAllAreas2[0];
              err = _yield$getAllAreas2[1];
              err ? showApiError(err) : setAreas(res);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAreas() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref5) {
      var values, isEdited, method, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref5.values, isEdited = _ref5.isEdited;

              if (!(!(values !== null && values !== void 0 && values.phones) && isNew)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", showError('Телефон за контакти е задължително поле!'));

            case 3:
              if (!isEdited) {
                _context2.next = 18;
                break;
              }

              method = isNew ? createBorrower : updateBorrower;
              params = isNew ? [values] : [borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number, _objectSpread(_objectSpread({}, borrowerData), values)];
              _context2.next = 8;
              return method.apply(void 0, params);

            case 8:
              _yield$method = _context2.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context2.next = 15;
                break;
              }

              showApiError(err);
              return _context2.abrupt("return", true);

            case 15:
              _isFunction(onBorrowerChange) && onBorrowerChange(res);
              _context2.next = 19;
              break;

            case 18:
              _isFunction(onCancel) && onCancel();

            case 19:
              _isFunction(onNext) && onNext();

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialFormData
  }, ___EmotionJSX("section", {
    css: sectionStyle,
    "data-section": "personal-info"
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-user"
  }), ___EmotionJSX("h5", null, "\u041B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "first_name",
    label: "\u0418\u043C\u0435",
    required: true,
    inputProps: {
      name: 'given-name',
      autoComplete: 'given-name',
      'data-field': 'first-name'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "middle_name",
    label: "\u041F\u0440\u0435\u0437\u0438\u043C\u0435",
    required: true,
    inputProps: {
      name: 'additional-name',
      autoComplete: 'additional-name',
      'data-field': 'middle-name'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "last_name",
    label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
    required: true,
    inputProps: {
      name: 'family-name',
      autoComplete: 'family-name',
      'data-field': 'last-name'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_number",
    label: "\u0415\u0413\u041D",
    required: true,
    disabled: true,
    inputProps: {
      name: 'national-id',
      inputMode: 'numeric',
      'data-field': 'national-id'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "email",
    label: "\u0418\u043C\u0435\u0439\u043B",
    validate: inputValidation('email'),
    inputProps: {
      name: 'email',
      type: 'email',
      autoComplete: 'email',
      inputMode: 'email',
      'data-field': 'email'
    }
  }))), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    margin: "0.5em 0 0 0"
  }, function (_ref7) {
    var setValues = _ref7.setValues,
        otherProps = _objectWithoutProperties(_ref7, _excluded);

    return ___EmotionJSX(PhonesInput, _extends({}, otherProps, {
      formId: "phones",
      onChange: function onChange(phones) {
        return setValues(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            phones: phones
          });
        });
      },
      required: true
    }));
  }))), ___EmotionJSX("section", {
    css: sectionStyle,
    "data-section": "id-card"
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-id-card"
  }), ___EmotionJSX("h5", null, "\u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    required: true,
    formId: "id_card_number",
    label: "\u041D\u043E\u043C\u0435\u0440",
    inputProps: {
      name: 'id-card-number',
      inputMode: 'numeric',
      'data-field': 'id-card-number'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(DateTimePicker, {
    required: true,
    formId: "id_card_issued_date",
    label: "\u0418\u0437\u0434\u0430\u0434\u0435\u043D\u0430 \u043D\u0430",
    timeFormat: false,
    dateFormat: dateFormat,
    inputProps: {
      placeholder: 'Издадена на',
      'data-field': 'id-card-issued-date'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(DateTimePicker, {
    formId: "id_card_valid_to_date",
    label: "\u0412\u0430\u043B\u0438\u0434\u043D\u0430 \u0434\u043E",
    timeFormat: false,
    dateFormat: dateFormat,
    inputProps: {
      placeholder: 'Валидна до',
      'data-field': 'id-card-valid-to'
    },
    isValidDate: function isValidDate(current) {
      return current.isSameOrAfter(moment(), 'day');
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_card_issued_from",
    label: "\u0418\u0437\u0434\u0430\u0434\u0435\u043D\u0430 \u043E\u0442",
    required: true,
    inputProps: {
      name: 'id-card-issuer',
      'data-field': 'id-card-issuer'
    }
  })))), ___EmotionJSX("section", {
    css: sectionStyle,
    "data-section": "id-card-address"
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-map-marker-alt"
  }), ___EmotionJSX("h5", null, "\u0410\u0434\u0440\u0435\u0441 \u043F\u043E \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, function (formProps) {
    var _ocrAddressLists$muni, _ocrAddressLists$citi;

    return ___EmotionJSX(AddressInput, {
      areas: areas,
      countryId: COUNTRY_ID,
      areaKey: "id_card_area_id",
      municipalityKey: "id_card_municipality_id",
      cityKey: "id_card_city_id",
      isNew: isNew,
      formProps: formProps,
      initialMunicipalities: (_ocrAddressLists$muni = ocrAddressLists === null || ocrAddressLists === void 0 ? void 0 : ocrAddressLists.municipalities) !== null && _ocrAddressLists$muni !== void 0 ? _ocrAddressLists$muni : [],
      initialCities: (_ocrAddressLists$citi = ocrAddressLists === null || ocrAddressLists === void 0 ? void 0 : ocrAddressLists.cities) !== null && _ocrAddressLists$citi !== void 0 ? _ocrAddressLists$citi : []
    });
  }), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_card_street",
    label: "\u0423\u043B\u0438\u0446\u0430",
    inputProps: {
      autoComplete: 'address-line1',
      'data-field': 'id-card-street'
    }
  }), ___EmotionJSX(Input, {
    formId: "id_card_street_number",
    label: "\u0423\u043B\u0438\u0446\u0430 \u2116",
    inputProps: {
      'data-field': 'id-card-street-number'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_card_quarter",
    label: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
    inputProps: {
      'data-field': 'id-card-quarter'
    }
  }), ___EmotionJSX(Input, {
    formId: "id_card_building",
    label: "\u0411\u043B\u043E\u043A",
    inputProps: {
      'data-field': 'id-card-building'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_card_entrance",
    label: "\u0412\u0445\u043E\u0434",
    inputProps: {
      'data-field': 'id-card-entrance'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_card_floor",
    label: "\u0415\u0442\u0430\u0436",
    inputProps: {
      inputMode: 'numeric',
      'data-field': 'id-card-floor'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "id_card_apartment",
    label: "\u0410\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442",
    inputProps: {
      'data-field': 'id-card-apartment'
    }
  })))), ___EmotionJSX("section", {
    css: sectionStyle,
    "data-section": "current-address"
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-home"
  }), ___EmotionJSX("h5", null, "\u041D\u0430\u0441\u0442\u043E\u044F\u0449 \u0430\u0434\u0440\u0435\u0441")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    margin: "0 0 1.2em 0"
  }, ___EmotionJSX(CheckButton, {
    formId: "sameAddresses"
  }, "\u0421\u044A\u0449\u0438\u0442\u0435 \u043A\u0430\u0442\u043E \u0430\u0434\u0440\u0435\u0441\u044A\u0442 \u043F\u043E \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430"))), function (formProps) {
    var _formProps$mergedValu;

    return !(formProps !== null && formProps !== void 0 && (_formProps$mergedValu = formProps.mergedValues) !== null && _formProps$mergedValu !== void 0 && _formProps$mergedValu.sameAddresses) && ___EmotionJSX(Row, {
      horizontalGap: 16
    }, ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, function (formProps) {
      return ___EmotionJSX(AddressInput, {
        areas: areas,
        countryId: COUNTRY_ID,
        areaKey: "current_area_id",
        municipalityKey: "current_municipality_id",
        cityKey: "current_city_id",
        isNew: isNew,
        formProps: formProps
      });
    }), ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Input, {
      formId: "current_street",
      label: "\u0423\u043B\u0438\u0446\u0430",
      inputProps: {
        autoComplete: 'street-address',
        'data-field': 'current-street'
      }
    }), ___EmotionJSX(Input, {
      formId: "current_street_number",
      label: "\u0423\u043B\u0438\u0446\u0430 \u2116",
      inputProps: {
        'data-field': 'current-street-number'
      }
    })), ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Input, {
      formId: "current_quarter",
      label: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
      inputProps: {
        'data-field': 'current-quarter'
      }
    }), ___EmotionJSX(Input, {
      formId: "current_building",
      label: "\u0411\u043B\u043E\u043A",
      inputProps: {
        'data-field': 'current-building'
      }
    })), ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Input, {
      formId: "current_entrance",
      label: "\u0412\u0445\u043E\u0434",
      inputProps: {
        'data-field': 'current-entrance'
      }
    })), ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Input, {
      formId: "current_floor",
      label: "\u0415\u0442\u0430\u0436",
      inputProps: {
        inputMode: 'numeric',
        'data-field': 'current-floor'
      }
    })), ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Input, {
      formId: "current_apartment",
      label: "\u0410\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442",
      inputProps: {
        'data-field': 'current-apartment'
      }
    })));
  }), ___EmotionJSX("section", {
    css: sectionStyle,
    "data-section": "additional-info"
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-clipboard-list"
  }), ___EmotionJSX("h5", null, "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0438 \u0434\u0430\u043D\u043D\u0438")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "marital_status",
    label: "\u0421\u0435\u043C\u0435\u0439\u043D\u043E \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    options: maritalStatusNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "education",
    label: "\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435",
    options: educationStatusNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "employment",
    label: "\u0422\u0440\u0443\u0434\u043E\u0432\u043E \u043F\u0440\u0430\u0432\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435",
    options: employmentTypeNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "accommodation_type",
    label: "\u0422\u0438\u043F \u043D\u0430\u0441\u0442\u0430\u043D\u044F\u0432\u0430\u043D\u0435",
    options: accommodationTypeNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "car_ownership",
    label: "\u041F\u043E\u043B\u0437\u0432\u0430 \u043B\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B?",
    options: carStatusNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  }))), ___EmotionJSX("div", {
    style: toggleGrid,
    "data-section": "declarations"
  }, ___EmotionJSX(CheckboxSwitch, {
    label: "\u0414\u0440\u0443\u0433\u043E \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u0442\u0432\u043E",
    formId: "other_citizenship"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "\u041F\u043E\u043B\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0430 \u043B\u0438\u0447\u043D\u043E\u0441\u0442",
    formId: "political_figure"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "\u041F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043C \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u0435\u043D \u0434\u043E\u0445\u043E\u0434",
    formId: "has_official_income"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "\u041D\u0435\u0442\u0435\u043D \u0434\u043E\u0445\u043E\u0434 \u043D\u0430\u0434 1500 \u043B\u0432",
    formId: "has_income_above_average_salary"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "\u0422\u0440\u0443\u0434\u043E\u0432 \u0441\u0442\u0430\u0436 \u043D\u0430\u0434 6 \u043C\u0435\u0441\u0435\u0446\u0430",
    formId: "has_current_work_experience_more_than_6"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "5 \u0438 \u043F\u043E\u0432\u0435\u0447\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    formId: "has_more_than_5_loans"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "\u0417\u0430\u0431\u0430\u0432\u0438 \u043F\u043E \u043A\u0440\u0435\u0434\u0438\u0442\u0438 \u043D\u0430\u0434 30 \u0434\u043D\u0438",
    formId: "has_loan_payment_delays_more_than_30_days"
  }), ___EmotionJSX(CheckboxSwitch, {
    label: "\u041F\u0435\u043D\u0441\u0438\u043E\u043D\u0435\u0440",
    formId: "is_retired"
  }))), ___EmotionJSX(Row, {
    horizontalGap: 16,
    margin: "2em 0 0 0"
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref8) {
    var onSubmit = _ref8.onSubmit;
    return ___EmotionJSX(React.Fragment, null, _isFunction(onBack) && ___EmotionJSX(Button, {
      type: "secondary",
      onClick: onBack,
      margin: "0 1em 0 0"
    }, "\u041D\u0430\u0437\u0430\u0434"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438"));
  })));
};

BorrowerDataForm.propTypes = {
  onBack: PropTypes.func,
  onBorrowerChange: PropTypes.func,
  onNext: PropTypes.func,
  onCancel: PropTypes.func,
  data: PropTypes.object,
  ocrData: PropTypes.object,
  ocrAddressLists: PropTypes.object
};
export default BorrowerDataForm;